import { styled, Text } from '@obvio/app'

import { Accordion, AccordionTitle, AccordionHead } from './Accordion'

import type { ReactElement } from 'react'

const FullWidthElement = styled(Accordion.Element)`
  width: 100%;
  text-align: left;
`

type AccordionDescriptionProps = {
  text: string
  accordion: {
    title: string
    data: {
      text: string
    }
  }[]
}
export function AccordionDescription({
  accordion,
  text,
}: AccordionDescriptionProps): ReactElement {
  return (
    <>
      <AccordionHead>{text}</AccordionHead>
      <Accordion>
        {accordion.map((item) => (
          <FullWidthElement
            key={item.title}
            title={<AccordionTitle>{item.title}</AccordionTitle>}
          >
            <Text>{item.data.text}</Text>
          </FullWidthElement>
        ))}
      </Accordion>
    </>
  )
}
